// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"617":"2e3d9bea","851":"fb87908a"}[chunkId] + ".chunk.js";
};